import { useState, useCallback } from "react";

const useTrackingForm = (isFormShown = false) => {
  const [isFormVisible, setIsFormVisible] = useState(isFormShown);

  const hideForm = useCallback(() => {
    setIsFormVisible(false);
  }, []);

  const showForm = useCallback(() => {
    setIsFormVisible(true);
  }, []);

  return {
    isFormVisible,
    setIsFormVisible,
    hideForm,
    showForm,
  };
};

export default useTrackingForm;
